import { createSlice } from '@reduxjs/toolkit'
import { setNestedKey } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { TYPE_SELECT_VIEW_BY } from '../constant'
import { convertDataChart, convertDataTable, getColumnTable } from '../helper'
import {
  getTrendByPortfolioCreditRisk,
  getTrendByPortfolioPerformanceScore,
} from './thunk'

const initialState = {
  activePort: {
    activePortfolio1: {},
    activePortfolio2: {},
  },
  dataTable: {},
  columnTable: [],
  dataChart: [],
  dataTablePer: {},
  columnTablePer: [],
  dataChartPer: [],
  viewBy: TYPE_SELECT_VIEW_BY[0],
  loading: true,
}

const slice = createSlice({
  initialState,
  name: 'portfolioScore/trendByPortfolio',
  reducers: {
    changeData: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state, path, data)
    },
  },
  extraReducers: (builder) => {
    //credit risk score
    builder.addCase(getTrendByPortfolioCreditRisk.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      getTrendByPortfolioCreditRisk.fulfilled,
      (state, { payload = [], meta }) => {
        state.dataChart = convertDataChart(payload, meta.arg['timeFrequency'])
        state.columnTable = [
          'name',
          ...getColumnTable(payload, meta.arg['timeFrequency']),
        ]
        state.dataTable = convertDataTable(payload, meta.arg['timeFrequency'])
        state.loading = false
      },
    )
    builder.addCase(
      getTrendByPortfolioCreditRisk.rejected,
      (state, { payload = [] }) => {
        state.loading = payload.loading
      },
    )
    //performance score
    builder.addCase(getTrendByPortfolioPerformanceScore.pending, (state) => {
      state.loading = true
    })
    builder.addCase(
      getTrendByPortfolioPerformanceScore.fulfilled,
      (state, { payload = [], meta }) => {
        state.dataChartPer = convertDataChart(
          payload,
          meta.arg['timeFrequency'],
        )
        state.columnTablePer = [
          'name',
          ...getColumnTable(payload, meta.arg['timeFrequency']),
        ]
        state.dataTablePer = convertDataTable(
          payload,
          meta.arg['timeFrequency'],
        )
        state.loading = false
      },
    )
    builder.addCase(
      getTrendByPortfolioPerformanceScore.rejected,
      (state, { payload = [] }) => {
        state.loading = payload.loading
      },
    )
  },
})

export const selectActivePortfolio = (type) => (state) =>
  state[slice.name].activePort[type]
export const selectViewBy = (state) => state[slice.name].viewBy
export const getDataReduxTable = (rowId, colId) => (state) => {
  if (!colId) return state[slice.name].dataTable[rowId]
  return state[slice.name].dataTable[rowId][colId]
}
export const selectColumnTable = (state) => state[slice.name].columnTable
export const selectDataChartPer = (state) => state[slice.name].dataChartPer
export const getDataReduxTablePer = (rowId, colId) => (state) => {
  if (!colId) return state[slice.name].dataTablePer[rowId]
  return state[slice.name].dataTablePer[rowId][colId]
}
export const selectColumnTablePer = (state) => state[slice.name].columnTablePer
export const selectDataChart = (state) => state[slice.name].dataChart
export const selectLoading = (state) => state[slice.name].loading

export const { changeData } = slice.actions

register(slice.name, slice.reducer)
